import React from "react";
import {
  Box,
  Chip,
  CircularProgress,
  Divider,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Edit as EditIcon, Delete as DeleteIcon } from "@material-ui/icons";

export default function CodesTable({
  codes,
  byToolboxId,
  loading,
  onRefresh,
  onNew,
  onEdit,
  onDelete,
  TopRightActions,
  NewButton,
}) {
  const getToolboxNameById = (id) => {
    const toolbox = byToolboxId[id];
    return toolbox?.toolbox_name || id;
  };
  return (
    <Paper variant="outlined">
      <Box p={2} display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h6">Access Codes</Typography>
        <Box display="flex" gridGap={8}>
          {TopRightActions}
          {NewButton}
        </Box>
      </Box>
      <Divider />
      <Box p={2}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Code</TableCell>
              <TableCell>Toolboxes Enabled</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(codes || []).map((c) => (
              <TableRow key={c._id} hover>
                <TableCell>{c.name}</TableCell>
                <TableCell style={{ maxWidth: 300 }}>
                  <Typography variant="body2" color="textSecondary" noWrap title={c.description}>
                    {c.description}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Chip label={c.code} size="small" color="quCreate" />
                </TableCell>
                <TableCell>
                  <Box display="flex" flexWrap="wrap" gridGap={6}>
                    {(c.toolboxes_enabled_ids || []).map((id) => (
                      <Chip key={id} label={getToolboxNameById(id)} size="small" />
                    ))}
                  </Box>
                </TableCell>
                <TableCell align="right">
                  <Tooltip title="Edit">
                    <IconButton onClick={() => onEdit?.(c)}>
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton onClick={() => onDelete?.(c)}>
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}

            {!codes?.length && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  {loading ? (
                    <Box display="flex" alignItems="center" justifyContent="center" py={4}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <Typography color="textSecondary">
                      No codes yet. Click "New Code" to add one.
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Box>
    </Paper>
  );
}
